<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Penarikan</h5>
            </template>
            <DetailGadaiKomp :detailGadai="dataDetailPenarikan" />
            <div class="detail-data-wrapper">
                <h6 class="form-title">DATA FOTO PENARIKAN</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto Penarikan</b-col>
                    <b-col>
                        <a v-bind:href="$baseFilePath+dataFotoPenarikan" target="_blank">
                            <img width="150px" :src="$baseFilePath+dataFotoPenarikan" alt="Foto Penarikan">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
            </div>
        </b-card>

    </div>
</template>

<script>
import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-penarikan',
    components: {
        DetailGadaiKomp,
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            dataDetailPenarikan: [],
            dataFotoPenarikan: ""
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleGadai = this.$axios.get(`gadai/detail/id/${this.id}`).then(response => {
                this.dataDetailPenarikan = response.data
            })

            let getFotoPenarikan = this.$axios.get(`daftar-penarikan/foto/?gadaiId=${this.id}`).then(response => {
                this.dataFotoPenarikan = response.data
            })

            Promise.all([getSingleGadai, getFotoPenarikan]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        
    },

    created(){
        this.init()
    }
}
</script>
